import React,{useEffect} from 'react';
import Marahaja from '../../videos/MaharajaVideo.mp4';
import premiumRoom from '../../images/hotel1.jpg';
import classic3 from '../../images/classic rooms/classic3.jpg';
import { Button, Carousel, Col, Container, Form, FormControl, FormGroup, FormLabel, NavLink, Row } from 'react-bootstrap';

import classic1 from '../../images/classic room converted/classic1.jpg';
import classic2 from '../../images/classic room converted/classic2.jpg';
import classic33 from '../../images/classic room converted/classic3.jpg';
import classic4 from '../../images/classic room converted/classic4.jpg';
import Maharaja01 from '../../images/maharaja/Maharaja01.jpg';
import Maharaja02 from '../../images/maharaja/Maharaja02.jpg';
import Maharaja04 from '../../images/maharaja/Maharaja04.jpg';
import Maharaja05 from '../../images/maharaja/Maharaja05.jpg';
import Maharaja07 from '../../images/maharaja/Maharaja07.jpg';
import Maharaja08 from '../../images/maharaja/Maharaja08.jpg';
import Maharaja09 from '../../images/maharaja/Maharaja09.jpg';
import Maharaja11 from '../../images/maharaja/Maharaja11.jpg';
import {IoIosArrowBack} from 'react-icons/io';
import { HashLink as Link } from 'react-router-hash-link';
import Aos from "aos";
import "aos/dist/aos.css";

// import './LuxRoom.css';

function MaharajaSuite() {

    useEffect(() => {
        window.scroll(0,0)
        Aos.init({duration:2000});
      }, []);


    return (
        <div>
            <section  className='HeaderPageWrapper'>
            <video className='videoTag' autoPlay loop muted >
                    <source src={Marahaja} type='video/mp4' />
                </video>
                {/* <img src={classic3} alt='tof' className='luxRoom' /> */}
                <div className='headerWrapper'>
                    <h1>MAHARAJA SUITE </h1>
                </div> 
            </section>
        <section className='DiscoverBody'>  
            <section id='lux' className='MovingCard1'>
            <div className='PrevBox'>
                <Link to='/discover/#maharaja' className='Previous' ><IoIosArrowBack />  Rooms /</Link>
                <Link className='present' to=''>Maharaja Suite</Link>
            </div>
            <div className='room-list-wrapper'>
              
                  <Container data-Aos='fade-in'  className='image-wrapper'>
                        {/* <video className='imageTag' controls  muted >
                            <source src={Video} type='video/mp4' />
                        </video> */}

                        <Carousel interval={null} fade='true'  >
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                              src = {Maharaja01}
                              alt = "" />
                          {/* <Carousel.Caption>
                            <h3>First slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                          </Carousel.Caption> */}
                          </Carousel.Item>
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                            src = {Maharaja02}
                            alt = "" />
                            {/* <Carousel.Caption>
                            <h3>Second slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                          </Carousel.Caption> */}
                          </Carousel.Item>
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                            src = {Maharaja04}
                            alt = "" />
                          {/* <Carousel.Caption>
                            <h3>Third slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                          </Carousel.Caption> */}
                          </Carousel.Item>
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                            src = {Maharaja05}
                            alt = "" />
                          {/* <Carousel.Caption>
                            <h3>Third slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                          </Carousel.Caption> */}
                          </Carousel.Item>
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                            src = {Maharaja07}
                            alt = "" />
                          {/* <Carousel.Caption>
                            <h3>Third slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                          </Carousel.Caption> */}
                          </Carousel.Item>
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                            src = {Maharaja08}
                            alt = "" />
                          {/* <Carousel.Caption>
                            <h3>Third slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                          </Carousel.Caption> */}
                          </Carousel.Item>
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                            src = {Maharaja09}
                            alt = "" />
                          {/* <Carousel.Caption>
                            <h3>Third slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                          </Carousel.Caption> */}
                          </Carousel.Item>
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                            src = {Maharaja11}
                            alt = "" />
                          {/* <Carousel.Caption>
                            <h3>Third slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                          </Carousel.Caption> */}
                          </Carousel.Item>
                    </Carousel> 
                      
                  </Container>
              
              
                  <div data-Aos='fade-in' className='features-wrapper1'>
                      <div className='content-header'>
                        <h3 className='executive-header'>MAHARAJA SUITE</h3>
                        {/* <p>7 well appointed Classic King Size Rooms...</p> */}
                      </div>
                      
                      <div>
                          <p>
                          Our Maharaja Suite have been carefully designed to offer you a 
                          Luxurious retreat for your time with us. Cosy colours, wood tones, 
                          office table and large windows, in-room private kitchen provide the perfect environment to relax, 
                          work and engage after an eventful day with folllowing facilities:
                          </p>
                          {/* <h6>
                            Here are rooms facilities:
                          </h6> */}
                          <div style={{display:'flex',justifyContent:'space-between'}}>
                          <ul>
                            <li>Air Conditioning</li>
                            <li>California King Size Bed</li>
                            <li>Premium Linen & Bedding</li>
                            <li>43’ Sony Bravia Smart TV</li>
                            <li>Amazon HD Fire Stick</li>
                            <li>Direct Dial Telephone</li>
                            <li>Bathroom with Shower</li>
                            <li>Razor Plug</li>
                            <li>Laundry Services (Fees are applied)</li>
                            <li>Extra Rollaway Bed (Chargeable)</li>
                            <li>24 Hrs Room Service</li>
                            <li>Electric Kettle</li>
                            <li>Essential Utensils</li>
                            <li>Dressing Table</li>
                            

                          </ul>
                          <ul>
                            <li>Full-Length Mirror</li>
                            <li>Kitchenette with Electric Stove</li>
                            <li>Loveseat Sofa with Coffee Table</li>
                            <li>Wake-Up Call</li>
                            <li>Office Table/Chair</li>
                            <li>Wi-Fi Internet Access Free of Charge</li>
                            <li>Bath Amenities – Herbal Soap & Shampoo</li>
                            <li>24 Hrs Hot Water</li>
                            <li>Closet with Lock</li>
                            <li>Daily Housekeeping</li>
                            <li>Modern Furnishing</li>
                            <li>Deep Room Sanitization</li>
                            <li>Complementary Water Bottles</li>
                            
                          </ul>
                          </div>
                          
                      </div>
                      {/* <div>

                      </div> */}


                      <div className='bookNowClassic'>
                          <a href='tel:918029901551'>
                            <Button className='bookNowlink'
                             style={{color:'#4d3319'}} to=''>Phone Bookings Only</Button>
                          </a>
                        
                      </div>
                  </div>
              
              

            </div>
          
        </section>
        </section>
        </div>
    )
}

export default MaharajaSuite
